export const getHyphenatedDate = (date: string): string => {
  const hyphenatedDate = date.replace(/\//g, '-');

  return hyphenatedDate;
};
